"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Colors_1 = __importDefault(require("../../assets/colors/Colors"));
const scale_1 = require("../../utils/scale");
const CustomText_1 = __importDefault(require("../text/CustomText"));
const PrimaryButton = ({ title, disabled = false, textStyle, onPress, style, noBoldText, }) => {
    return (react_1.default.createElement(react_native_1.TouchableOpacity, { disabled: disabled, onPress, style: [styles.defaultButton, style] },
        react_1.default.createElement(CustomText_1.default, { weight: noBoldText ? "300" : "600", style: [styles.defaultText, textStyle] }, title)));
};
const styles = react_native_1.StyleSheet.create({
    defaultButton: {
        borderRadius: 100,
        backgroundColor: Colors_1.default.primaryColor,
        height: (0, scale_1.verticalScale)(54),
        justifyContent: 'center',
        paddingHorizontal: 20,
        alignItems: 'center',
    },
    defaultText: {
        color: Colors_1.default.white,
        fontSize: 16,
        fontWeight: 'bold',
    },
});
exports.default = PrimaryButton;
